import { instanceForUspacy } from '../../config/axios.config';
import { USPACY_API } from '../../constants/uspacyAPI';
export var uspacyService = {
    getFunnels: function () { return instanceForUspacy.get("".concat(USPACY_API.GET_FUNNELS)); },
    getPortalUsers: function () { return instanceForUspacy.get("".concat(USPACY_API.GET_PORTAL_USERS)); },
};
